<app-type-select
  [onlyActive]="false"
  (select)="onSelect($event)"
  [parentFormGroup]="form"
  [groupType]="groupType"
  class="kendo-select-filter"
  [isInModal]="false"
>
</app-type-select>
